document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tab-section__title-item");
  const tabContents = document.querySelectorAll(".tab-section__body-item");

  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const target = this.dataset.title;

      // Remove active classes from buttons
      tabButtons.forEach((btn) => {
        btn.classList.remove("active");
      });

      // Remove active classes from contents
      tabContents.forEach((content) => {
        content.classList.remove("active");
      });

      // Activate clicked button
      this.classList.add("active");

      // Activate matching content
      const activeContent = document.querySelector(
        `.tab-section__body-item[data-content="${target}"]`
      );

      if (activeContent) {
        activeContent.classList.add("active");
      }
    });
  });
});